import { render, staticRenderFns } from "./RemuneracaoMedicaNavBar.vue?vue&type=template&id=7a8b9924&scoped=true"
import script from "./RemuneracaoMedicaNavBar.vue?vue&type=script&lang=ts"
export * from "./RemuneracaoMedicaNavBar.vue?vue&type=script&lang=ts"
import style0 from "./RemuneracaoMedicaNavBar.vue?vue&type=style&index=0&id=7a8b9924&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8b9924",
  null
  
)

export default component.exports